(function () {
  var STORAGE_KEY = 'eco-vanille:held-cart-items';

  function readHeldItems() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  var heldItems = readHeldItems();
  if (heldItems.length === 0) return;

  fetch(routes.cart_add_url + '.js', { ...fetchConfig(), ...{ body: JSON.stringify({ items: heldItems }) } })
    .then(function (response) {
      return response.json();
    })
    .then(function (result) {
      if (result.status) return;
      localStorage.removeItem(STORAGE_KEY);
      refreshCartIcon();
    })
    .catch(function () {});

  function refreshCartIcon() {
    fetch(routes.cart_url + '?section_id=cart-icon-bubble')
      .then(function (response) {
        return response.text();
      })
      .then(function (responseText) {
        var html = new DOMParser().parseFromString(responseText, 'text/html');
        var source = html.querySelector('.shopify-section');
        var target = document.getElementById('cart-icon-bubble');
        if (source && target) {
          target.innerHTML = source.innerHTML;
        }
      })
      .catch(function () {});
  }
})();
